<card-default [description]="'COMPANY.SELF_FILER_CODE_DESC'">
  <div *ngIf="open">
    <div class="form-row">
      <div class="col-12">
        <app-control-wrapper [control]="fg.get('filerCode')" [errors]="errors" [helper]="'FORM_HELPER.FILER_CODE'">
          <label control-label for="filerCode">{{ "FORM_LABEL.FILER_CODE" | translate }}</label>
          <input
            control-wrapper
            type="text"
            [formControl]="fg.get('filerCode')"
            class="form-control"
            id="filerCode"
            name="filerCode"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F{3}'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            [maxMaskLength]="3"
          />
        </app-control-wrapper>
      </div>
      <div *ngIf="mainPort; else mainPortForm" class="col-12">
        <card-default>
          <div class="port-label">
            {{ "FORM_LABEL.MAIN_PORT_OF_ENTRY" | translate }}
          </div>
          <div class="port-value">{{ mainPort.code }} {{ mainPort.description }}</div>
        </card-default>
      </div>
      <ng-template #mainPortForm>
        <div class="col-12">
          <auto-select
            [label]="'FORM_LABEL.MAIN_PORT_OF_ENTRY'"
            [bindValue]="'code'"
            [bindLabel]="['code', 'description']"
            [change]="searchPort()"
            [fc]="fg.get('mainPortCode')"
            [multiple]="false"
            [helper]="'FORM_HELPER.MAIN_PORT_OF_ENTRY'"
            [placeholder]="'FORM_PLACEHOLDER.MAIN_PORT_OF_ENTRY'"
            [errors]="errors"
          ></auto-select>
        </div>
      </ng-template>
      <div class="col-12">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isFormChecked" [formControl]="fg.get('isFormChecked')" />
            <label class="custom-control-label" for="isFormChecked">
              {{ "ON_BOARDING.SELF_FILER_RECEIVED_FILER_CODE_FROM_PORT_DIRECTOR" | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button card-footer *ngIf="!open" type="button" class="btn btn-primary" (click)="openFilerCodeForm()">
    {{ "ON_BOARDING.HAVE_FILER" | translate }}
  </button>
  <button card-footer *ngIf="open" type="button" class="btn btn-primary" (click)="onSave()" [disabled]="fg.invalid">
    {{ "BUTTON.SAVE" | translate }}
  </button>
</card-default>

<custom-modal [(open)]="isShowWarningFilerCodeModal" [header]="'FORM_LABEL.FILER_CODE'">
  <div [innerHTML]="'ON_BOARDING.SELF_FILER_CODE_WARNING_DESCRIPTION' | translate"></div>
  <button footer-action class="btn btn-primary" type="button" (click)="isShowWarningFilerCodeModal = false">
    {{ "BUTTON.OK" | translate }}
  </button>
</custom-modal>
